import i18next, { i18n as i18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { languages } from './i18n.constants';
import { ptbr } from './locales/ptbr/ptbr';
import { en } from './locales/en/en';

const createI18n = (language: string): i18nInstance => {
  const i18n = i18next.createInstance().use(initReactI18next);

  i18n.init({
    lng: language,
    fallbackLng: language,
    resources: {
      [languages.en]: en,
      [languages.pt]: ptbr,
    },
  });

  return i18n;
};

export const i18n = createI18n(navigator.language || languages.pt);

export default i18n;
